<!-- 产品装小箱管理 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w300 mr-24 mb-24" type="text" v-model="storePrams.qrcode_number" placeholder="请输入或扫描产品溯源码编码查询外箱"></Input>
            <Input class="w200 mr-24 mb-24" type="text" v-model="storePrams.box_number" placeholder="请输入或扫描外箱码查询"></Input>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.batch_id" clearable filterable placeholder="请选择关联批次">
                <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
            </Select>
            <Select class="w200 mr-24 mb-24" v-model="storePrams.product_id" clearable filterable placeholder="请选择关联产品">
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
            </Select>
            <Button class="theme-bc mb-24" icon="ios-search" type="warning" @click="goSearch">确定搜索</Button>
        </div>
        <div class="content">
            <div>
                <Button class="theme-bc mr-24 mb-24" type="warning" @click="goPacking">产品装箱操作</Button>
                <Button class="mr-24 mb-24" type="warning" ghost @click="goRepair">补码入箱操作</Button>
                <Button class="mr-24 mb-24" type="warning" ghost @click="goUnpacking">拆码出箱(拆箱操作)</Button>
                <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                    <template slot-scope="{ row }" slot="count">
                        <Button type="default" @click="goDetails(row)">{{row.count}}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sb">
                            <Button type="success" ghost label="small" @click="goPacking(row)">装箱</Button>
                            <Button type="primary" ghost label="small" @click="goUnpacking(row)">拆箱</Button>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr-24 ml-24">已经选择{{delData.length}}个</span>
                    <Button type="error" ghost label="large" @click="goDel">拆箱</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>

        <Drawer v-model="drawerModal" :title="drawerTitle" width="66" :styles="styles">
            <!-- 详情 -->
            <template v-if="drawerId == 1">
                <Table :columns="columnsDrawer" :data="dataDrawer" border>
                    <template slot-scope="{ row }" slot="product_imgs">
                        <div v-if="row.product_qrcode.product" class="flex-c">
                            <img class="table_img" v-if="row.product_qrcode.product.product_imgs" :src="row.product_qrcode.product.show_product_imgs[0]">
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="product_name">
                        <div v-if="row.product_qrcode">{{row.product_qrcode.product ? row.product_qrcode.product.product_name : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="specs">
                        <div v-if="row.product_qrcode">{{row.product_qrcode.product ? row.product_qrcode.product.specs : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="qrcode_number">
                        <div v-if="row.product_qrcode">{{row.product_qrcode.product ? row.product_qrcode.qrcode_number : ''}}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <Button type="primary" ghost label="small" @click="goUnpackingTip(row)">拆箱</Button>
                    </template>
                </Table>
                <div class="page_drawer">
                    <Page :current="pageDrawer.page" :page-size="pageDrawer.limit" :total="totalDrawer" show-elevator show-total @on-change="changeDrawer"/>
                </div>
            </template>
            <!-- 产品装箱操作 -->
            <template v-if="drawerId == 2">
                <Form :model="formData" label-position="right" :label-width="100">
                    <div class="form-header">
                        <img  class="w-h-24 mr-12" src="../../assets/information.png">
                        <div style="color: #FF761D;">为规范操作，如果需要装箱的产品之前装过箱，后台装箱需要将该产品拆箱后再装，否则会过滤该产品并提示已装过箱。 </div>
                    </div>
                    <FormItem label="外箱码：">
                        <div class="dis-flex">
                            <Input class="w30-vw mr-24" v-model="formData.small_box_number" placeholder="录入已有外箱码"/>
                            <Button type="success" @click="getPackingCountRound">随机生成</Button>
                            <Button class="theme-bc ml-24" type="warning" @click="goSelectCode">选择箱码</Button>
                        </div>
                    </FormItem>
                    <FormItem label="录入方式：">
                        <RadioGroup v-model="formData.type" type="button" @on-change="changeFilter">
                            <Radio label="1">扫溯源码</Radio>
                            <Radio label="2">筛选录入</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入溯源码：">
                        <div class="dis-flex">
                            <Input @input="handleInputChange" class="w30-vw mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入产品上的溯源码编码，一行一个，支持手工录入和扫码枪扫码录入"></Input>
                            <div style="display: flex;flex-direction: column;justify-content: space-between;">
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div style="display: flex;align-items: center;cursor: pointer;" @click="goBlank"><img src="@/assets/blank.png" alt="" style="display: block;margin-right: 6px;"><div>置空</div></div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr-24" @click="cancelDrawer">取消</Button>
                    <Button class="theme-bc" type="warning" @click="submitDrawer">确定装箱</Button>
                </div>
            </template>
            <!-- 补码入箱操作 -->
            <template v-if="drawerId == 3">
                <Form :model="formData" label-position="right" :label-width="100">
                    <div class="form-header">
                        <img  class="w-h-24 mr-12" src="../../assets/information.png">
                        <div style="color: #FF761D;">为规范操作，如果需要装箱的产品之前装过箱，后台装箱需要将该产品拆箱后再装，否则会过滤该产品并提示已装过箱。 </div>
                    </div>
                    <FormItem label="外箱码：">
                        <div class="dis-flex">
                            <Input class="w30-vw mr-24" v-model="formData.small_box_number" placeholder="录入要补码的外箱码"/>
                            <Button class="theme-bc" type="warning" @click="goSelectCode">选择箱码</Button>
                        </div>
                    </FormItem>
                    <FormItem label="录入方式：">
                        <RadioGroup v-model="formData.type" type="button" @on-change="changeFilter">
                            <Radio label="1">扫溯源码</Radio>
                            <Radio label="2">筛选录入</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="录入溯源码：">
                        <div class="dis-flex">
                            <Input @input="handleInputChange" class="w30-vw mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入产品上的溯源码编码，一行一个，支持手工录入和扫码枪扫码录入"></Input>
                            <div style="display: flex;flex-direction: column;justify-content: space-between;">
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div style="display: flex;align-items: center;cursor: pointer;" @click="goBlank"><img src="@/assets/blank.png" alt="" style="display: block;margin-right: 6px;"><div>置空</div></div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr-24" @click="cancelDrawer">取消</Button>
                    <Button class="theme-bc" type="warning" @click="submitDrawer">补码入箱</Button>
                </div>
            </template>
            <!-- 拆码出箱(拆箱操作) -->
            <template v-if="drawerId == 4">
                <Form :model="formData" label-position="right" :label-width="100">
                    <FormItem label="录入方式：">
                        <RadioGroup v-model="formData.type" type="button">
                            <Radio label="1">溯源码拆箱</Radio>
                            <Radio label="3">小箱码拆箱</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="溯源码数据：">
                        <div class="dis-flex">
                            <Input @input="handleInputChange" class="w30-vw mr-24" type="textarea" v-model="qrcode_number" :autosize="{minRows: 10}" placeholder="录入产品上的溯源码编码，一行一个，支持手工录入和扫码枪扫码录入"></Input>
                            <div style="display: flex;flex-direction: column;justify-content: space-between;">
                                <div>支持手动和扫码枪扫码录入。</div>
                                <div style="display: flex;align-items: center;cursor: pointer;" @click="goBlank"><img src="@/assets/blank.png" alt="" style="display: block;margin-right: 6px;"><div>置空</div></div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
                <div class="drawer-footer">
                    <Button class="mr-24" @click="cancelDrawer">取消</Button>
                    <Button class="theme-bc" type="warning" @click="submitDrawer">确定</Button>
                </div>
            </template>
        </Drawer>
        <!-- 选择箱码 -->
        <Drawer v-model="selectCodeModal" title="选择箱码" width="66" :styles="styles">
            <Select class="w200 mr-24 mb-24" v-model="pageCode.product_id" clearable filterable placeholder="关联产品">
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
            </Select>
            <Button class="theme-bc mb-24" icon="ios-search" type="warning" @click="getCode">确定搜索</Button>
            <Table :columns="columnsCode" :data="dataCode" border></Table>
            <div class="page_drawer">
                <Page :current="pageCode.page" :page-size="pageCode.limit" :total="total" show-elevator show-total @on-change="pageChangeCode"/>
            </div>
            <div class="drawer-footer">
                <Button class="mr-24" @click="cancelCode">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitCode">确定</Button>
            </div>
        </Drawer>
        <!-- 筛选录入 -->
        <Drawer v-model="filterModal" title="筛选录入" width="66" :styles="styles" @on-close="closeFilter">
            <Input class="w200 mr-24 mb-24" type="text" v-model="pageFilter.start_id" placeholder="起始ID"></Input>
            <Input class="w200 mr-24 mb-24" type="text" v-model="pageFilter.end_id" placeholder="截止ID"></Input>
            <Select class="w200 mr-24 mb-24" v-model="pageFilter.batch_id" clearable filterable placeholder="请选择批次">
                <Option v-for="item in batchList" :value="item.id" :key="item.id">{{ item.batch_name }}</Option>
            </Select>
            <Select class="w200 mr-24 mb-24" v-model="pageFilter.product_id" clearable filterable placeholder="请选择产品">
                <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.product_name }}</Option>
            </Select>
            <Button class="theme-bc mb-24" icon="ios-search" type="warning" @click="getFilter">确定搜索</Button>
            <Table ref="selection" :columns="columnsFilter" :data="dataFilter" border @on-selection-change="changeSelectionFilter">
                <template slot-scope="{ row }" slot="batch_name">
                    <div>{{row.batch ? row.batch.batch_name : ''}}</div>
                </template>
                <template slot-scope="{ row }" slot="product_name">
                    <div>{{row.product ? row.product.product_name : ''}}</div>
                </template>
            </Table>
            <div class="page_drawer">
                <Page :current="pageFilter.page" :page-size="pageFilter.limit" :total="totalFilter" show-elevator show-total @on-change="pageChangeFilter"/>
            </div>
            <div class="drawer-footer">
                <Button class="mr-24" @click="cancelFilter">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitFilter">确定</Button>
            </div>
        </Drawer>
    </div>
</template>

<script>
import {
    packing_small_list,
    packing_small_tostart, 
    packing_small_product, 
    packing_count_round, 
    packing_unpack,
    qrcode_filter,
} from '@/api/index';
import { batch_select, product_select, } from '@/api/select';
export default {
    data() {
        return {
            qrcode_number: "",
            small_box_number: "",
            storePrams: {
                page: 1,
                limit: 10,
                qrcode_number: "",
                box_number: "",
                batch_id: "",
                product_id: "",
            },
            total: 0,
            batchList: [],
            productList: [],
            columnsTable: [
                { type: 'selection', width: 60, align: 'center' },
                { type: 'index', width: 60, align: 'center' },
                { title: "小箱外箱码", key: "small_box_number", align: "center" },
                { title: "关联大箱码", key: "big_box_number", align: "center" },
                { title: "装箱数量", slot: "count", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            drawerModal: false,
            drawerTitle: "",
            drawerId: 0,
            columnsDrawer: [
                { type: 'index', width: 60, align: 'center' },
                { title: "图片", slot: "product_imgs", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
                { title: "规格", slot: "specs", align: "center" },
                { title: "产品编码", slot: "qrcode_number", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataDrawer: [],
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            pageDrawer: {
                page: 1,
                limit: 10,
            },
            totalDrawer: 0,
            formData: {
                qrcode_number: [],
                small_box_number: "",
                is_round: 0,
                is_exist: 0,
                type: '1',
            },
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            selectCodeModal: false,
            dataCode: [],
            pageCode: {
                page: 1,
                limit: 10,
                product_id: '',
            },
            filterModal: false,
            pageFilter: {
                page: 1,
                limit: 10,
                start_id: "",
                end_id: "",
                product_id: "",
                batch_id: "",
            },
            totalFilter: 0,
            columnsFilter: [
                { type: 'selection', width: 60, align: 'center' },
                { title: "ID号", key: "id", align: "center" },
                { title: "溯源码编码", key: "qrcode_number", align: "center" },
                { title: "批次名称", slot: "batch_name", align: "center" },
                { title: "产品名称", slot: "product_name", align: "center" },
            ],
            dataFilter: [],
            filter_data: '',
            selectedId: null, // 存储选中的ID
        };
    },
    mounted() {
        this.getList();
        this.getBatchSelect();
        this.getProductSelect();
    },
    computed: {
        columnsCode() {
            return [
                {
                    title: '选择',
                    width: 100,
                    render: (h, params) => {
                        return h('Checkbox', {
                            props: {
                                value: this.selectedId === params.row.id
                            },
                            on: {
                                'on-change': () => this.selectRow(params.row)
                            }
                        });
                    }
                },
                { title: "小箱码", key: "small_box_number", align: "center" },
                { title: "大箱码", key: "big_box_number", align: "center" },
                { title: "箱内产品数量", key: "count", align: "center" }
            ];
        }
    },
    methods: {
        handleInputChange(e){
            console.log('handleInputChange')
            // 获取当前输入框的值
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入）
            const lines = inputValue.split('\n');
            // 用于存储处理后的所有码
            const allCodes = [];
            // 匹配完整URL的正则表达式（支持https/http）
            const urlPattern = /https?:\/\/[^\s?]+\?q=([\w]+)/g;
            // 处理每一行数据
            lines.forEach(line => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的q参数值
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line.substring(lastIndex, match.index).trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取的q参数值
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内容
                    }
                }
                // 收集当前行的所有结果
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行）
            this.qrcode_number = allCodes.filter(code => code.trim() !== '').join('\n');
        },
        selectRow(e) {
            console.log('selectRow')
            this.selectedId = e.id;
            this.formData.small_box_number = e.small_box_number;
        },
        getFilter(){
            console.log('getFilter')
            qrcode_filter(this.pageFilter).then((res) => {
                this.dataFilter = res.data.data;
                this.totalFilter = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        changeSelectionFilter(e){
            console.log('changeSelectionFilter')
            this.filter_data = e
                .map(item => item.qrcode_number)          // 提取所有值
                .filter(code => code && code.trim())      // 过滤空值
                .filter((code, index, self) => self.indexOf(code) === index) // 去重
                .join('\n'); 
        },
        pageChangeFilter(index){
            console.log('pageChangeFilter')
            this.pageFilter.page = index;
            this.getFilter()
        },
        submitFilter(){
            console.log('submitFilter')
            if(this.qrcode_number){
                this.qrcode_number += '\n' + this.filter_data;
            }else {
                this.qrcode_number += this.filter_data;
            }
            if (!this.filter_data) {
                this.$Message.error('请选择溯源码编码');
                return
            }
            this.formData.type = '1'
            this.filterModal = false;
        },
        cancelFilter(){
            console.log('cancelFilter')
            this.formData.type = '1'
            this.filterModal = false;
        },
        closeFilter(){
            console.log('closeFilter')
            this.formData.type = '1'
        },
        changeFilter(e){
            console.log('changeFilter')
            if(e == 2){
                this.pageFilter.page = 1
                this.pageFilter.limit = 10
                this.pageFilter.start_id = ''
                this.pageFilter.end_id = ''
                this.pageFilter.product_id = ''
                this.pageFilter.batch_id = ''
                this.getFilter()
                // 延时器
                setTimeout(() => {
                    this.filterModal = true;
                }, 500);
            }
        },
        submitCode(){
            console.log('submitCode')
            if (!this.formData.small_box_number) {
                this.$Message.error('请选择小箱码');
                return
            }
            this.selectCodeModal = false;
        },
        cancelCode(){
            console.log('cancelCode')
            this.selectCodeModal = false;
        },
        getCode() {
            console.log('getCode')
            packing_small_list(this.pageCode).then((res) => {
                this.dataCode = res.data.data;
                this.total = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChangeCode(index) {
            console.log('pageChangeCode')
            this.pageCode.page = index;
            this.getCode()
        },
        goSelectCode(){
            console.log('goSelectCode')
            this.getCode()
            this.selectCodeModal = true
        },
        goUnpackingTip(row){
            console.log('goUnpackingTip')
            var qrcode_number = row.qrcode_number.split('\n')
                    .map(item => item === '' ? null : item) // 将空字符串转为 null
                    .filter(item => item !== null); // 过滤掉所有 null 值
            this.$Modal.confirm({
                title: '是否将此溯源码拆出！',
                content: '将此溯源码从小箱中拆出',
                onOk: () => {
                    var data = {
                        type: 1,
                        qrcode_number: qrcode_number
                    }
                    packing_unpack(data).then( res => {
                        this.getPackingSmallProduct();
                        this.getList();
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    }) 
                },
                onCancel: () => {
                }
            }); 
        },
        goBlank(){
            console.log('goBlank')
            this.qrcode_number = '';
        },
        // 产品装小箱列表
        getList() {
            console.log('getList')
            packing_small_list(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
                // 删除后，page--
                if(!res.data.data.length && this.storePrams.page != 1){
                    this.storePrams.page --;
                    this.getList();
                }
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 详情
        getPackingSmallProduct(){
            console.log('getPackingSmallProduct')
            packing_small_product({small_box_number: this.small_box_number}).then((res) => {
                this.dataDrawer = res.data.data;
                this.totalDrawer = res.data.total;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 批次下拉
        getBatchSelect(){
            batch_select().then((res) => {
                this.batchList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        // 产品下拉
        getProductSelect(){
            product_select().then((res) => {
                this.productList = res.data;
            })
            .catch((err) => {
                this.$Message.error(err.msg);
            });
        },
        pageChange(index) {
            console.log('pageChange')
            this.storePrams.page = index;
            this.getList();
        },
        changeDrawer(index){
            console.log('changeDrawer')
            this.pageDrawer.page = index;
            this.getList();
        },
        goSearch() {
            console.log('goSearch')
            this.getList();
        },
        goDetails(row){
            console.log('goDetails')
            this.small_box_number = row.small_box_number;
            this.getPackingSmallProduct();
            this.drawerTitle = row.small_box_number + "小箱详情";
            this.drawerId = 1;
            setTimeout(() => {
                this.drawerModal = true;
            }, 300);
        },
        goPacking(row){
            console.log('goPacking')
            if(row.id){
                this.formData.small_box_number = row.small_box_number
            }else{
                this.formData.small_box_number = "";
            }
            this.formData.is_exist = 0;
            this.formData.qrcode_number = [];
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "产品装箱操作";
            this.drawerId = 2;
            this.formData.type = '1'
            this.drawerModal = true;
        },
        goRepair(){
            console.log('goRepair')
            this.formData.is_exist = 1;
            this.formData.qrcode_number = [];
            this.formData.small_box_number = "";
            this.formData.is_round = 0;
            this.qrcode_number = "";
            this.drawerTitle = "补码入箱操作";
            this.drawerId = 3;
            this.formData.type = '1'
            this.drawerModal = true;
        },
        goUnpacking(row){
            console.log('goUnpacking')
            if(row.id){
                this.formData.type = '3';
                this.qrcode_number = row.small_box_number;
            }else{
                this.qrcode_number = "";
            }
            this.formData.qrcode_number = [];
            this.drawerTitle = "拆码出箱(拆箱操作)";
            this.drawerId = 4;
            this.drawerModal = true;
        },
        goDel(){
            console.log('goDel')
            if(this.delData.length == 0){
                this.$Message.error('请选择');
                return
            }
            let that = this;
            this.$Modal.confirm({
                title: '拆码出箱！',
                content: '将小箱码从小箱中拆出',
                onOk: () => {
                    var del_id = [];
                    this.delData.forEach(item => {
                        del_id.push(item.small_box_number)
                    });
                    this.del_id = del_id.join(',');
                    var data = {
                        type: 3,
                        small_box_number: this.del_id
                    }
                    packing_unpack(data).then(res=>{
                        that.getList();
                        this.del_value = false;
                        this.$Message.success(res.msg);
                    }).catch(res=>{
                        this.$Message.error(res.msg);
                    })
                },
                onCancel: () => {
                }
            }); 
        },
        // selection
        changeSelection(e){
            console.log('changeSelection')
            this.delData = e;
            if(this.dataTable.length === e.length){
                this.del_value = true;
            }else{
                this.del_value = false;
            }
        },
        handleSelectAll(e){
            console.log('handleSelectAll')
            if(e == true){
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            }else{
                this.$refs.selection.selectAll(false);
            }
        },
        getPackingCountRound(){
            console.log('getPackingCountRound')
            this.formData.is_round = 1;
            packing_count_round().then( res => {
                this.formData.small_box_number = res.data;
            }).catch(res=>{
                this.$Message.error(res.msg);
            })
        },
        // 确定
        submitDrawer(){
            console.log('submitDrawer')
            if(this.qrcode_number){
                this.formData.qrcode_number = this.qrcode_number.split('\n')
                    .map(item => item === '' ? null : item) // 将空字符串转为 null
                    .filter(item => item !== null); // 过滤掉所有 null 值
            }
            // 拆码出箱(拆箱操作)
            if(this.drawerId == 4){
                if(this.formData.type == 1){
                    var data = {
                        type: this.formData.type,
                        qrcode_number: this.formData.qrcode_number
                    }
                }else if(this.formData.type == 3){
                    var data = {
                        type: this.formData.type,
                        small_box_number: this.formData.qrcode_number
                    }
                }
                packing_unpack(data).then( res => {
                    this.getList();
                    this.drawerModal = false;
                    this.$Message.success(res.msg);
                }).catch(res=>{
                    this.$Message.error(res.msg);
                }) 
                return
            }
            var data = {
                is_exist: this.formData.is_exist,
                is_round: this.formData.is_round,
                qrcode_number: this.formData.qrcode_number,
                small_box_number: this.formData.small_box_number
            }
            packing_small_tostart(data).then( res => {
                this.getList();
                this.drawerModal = false;
                this.$Message.success(res.msg);
            }).catch(res=>{
                this.$Message.error(res.msg);
            }) 
        },
        cancelDrawer(){
            console.log('cancelDrawer')
            this.drawerModal = false;
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.form-header {
    padding: 24px;
    display: flex;
    align-items: center;
}
.w-h-24 {
    width: 24px;
    height: 24px;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page_drawer {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table_img {
    margin: 12px 0;
    width: 50px;
    height: 50px;
}
::v-deep .ivu-input-search {
    background: #53C41A !important;
    border-color: #53C41A !important;
}
::v-deep .ivu-checkbox{
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.w30-vw {
    width: 30vw;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53C41A;
    border-color: #53C41A;
    color: #ffffff;
    box-shadow: none;
    z-index: 1;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
    margin-right: 24px;
}
.dis-flex {
    display: flex;
}
.checkbox-ml {
    margin-left: 20px !important;
}
.drawer-footer {
    padding: 12px 24px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    text-align: right;
    background: #fff;
}
</style>